import { all, put, call, select, takeEvery } from 'redux-saga/effects'
import FileSaver from 'file-saver'

import { DOWNLOAD_IMPORTER, FILE_NAME, LOCALE_PREFIX } from './constants'

import { importerFileRequest } from './helpers'
import { showLoader, hideLoader } from '../Loader/actions'

import { sessionIdSelector } from './selectors'

import { error } from '../../../../../../../../services/toastr'

function* downloadImporter(_action) {
    const contentId = _action.data.contentId || null

    if (!contentId) return null

    yield put(showLoader(contentId))

    const sessionId = yield select(sessionIdSelector)

    const importerFileBlob = yield call(importerFileRequest, sessionId, FILE_NAME)

    if (!importerFileBlob || !importerFileBlob.size) {
        error(`${LOCALE_PREFIX}.error`)
        return null
    }

    FileSaver.saveAs(importerFileBlob, FILE_NAME)

    yield put(hideLoader(contentId))

    return null
}

export default function* importerSaga() {
    yield all([takeEvery(DOWNLOAD_IMPORTER, downloadImporter)])
}
